import { useTranslation } from 'react-i18next';

import { DefineFilters, useIsMobile } from '@tq/ui-components';
import { Comment } from 'types';
import { uniqBy } from 'tools';

export const useCommentFilters = (comments?: Comment[]): DefineFilters[] => {
  const { t } = useTranslation('case_details_comments');

  const isMobile = useIsMobile();

  return [
    {
      type: 'group',
      filtersInGroup: [
        {
          type: 'filter',
          controlLabel: `${t('comment_type', 'Comment type')}:`,
          filterModalHeader: t('comments_filter', 'Comments filter'),
          filterOptions: [
            {
              column: 'type',
              label: t('all', 'All'),
            },
            ...uniqBy(comments ?? [], (comment) => comment.type).map((comment) => ({
              column: 'type',
              value: comment.type,
              label: comment.type,
            })),
          ],
        },
        {
          type: 'sort',
          controlLabel: `${isMobile ? t('sort', 'Sort') : t('sort_by', 'Sort by')}:`,
          groupSortOptions: [
            {
              label: t('date_published', 'Date published'),
              options: [
                {
                  column: 'datePublished',
                  label: t('date_published_newest', 'Newest'),
                  desc: true,
                },
                {
                  column: 'datePublished',
                  label: t('date_published_oldest', 'Oldest'),
                  desc: false,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};
